import { render } from "./milestone-form-footer-delete-button.vue?vue&type=template&id=24da347a&scoped=true&ts=true"
import script from "./milestone-form-footer-delete-button.vue?vue&type=script&lang=ts"
export * from "./milestone-form-footer-delete-button.vue?vue&type=script&lang=ts"

import "./milestone-form-footer-delete-button.vue?vue&type=style&index=0&id=24da347a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24da347a"]])

export default __exports__